import React, { useRef } from "react";
import JoditEditor from "jodit-react";

const TextEditor = ({ textEditorData, setTextEditorData }) => {
  const editor = useRef(null);

  const config = {
    readonly: false,
    minHeight: "500px",
  };

  return (
    <JoditEditor
      ref={editor}
      value={textEditorData}
      config={config}
      onBlur={(val) => setTextEditorData(val)}
      // onChange={handleChange}
    />
  );
};

export default TextEditor;
